export default "__VITE_ASSET__DMQWx7y2__"